import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import loader from "./../../assets/loading/loader.gif"
import { AuthUser } from "API/UserAccess"
import { usePermissions } from "API/PermissionContext"

const Roles = () => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.ROLES_USERS
  const [dataLoaded, setDataLoaded] = useState(false)
  const [roles, setRoles] = useState([])
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [roleId, setRoleId] = useState("")
  const [search, setSearch] = useState({ rolesType: "", accessLevel: "" })
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  const fetchData = useCallback(async () => {
    try {
      const response = await api.get("role-by/" + (AuthUser?.role || 7))
      const d = Array.isArray(response.data.data) ? response.data.data : response.data.data?.data || []
      setRoles(d)
    } catch (err) { console.error(err) }
    setDataLoaded(true)
  }, [])

  useEffect(() => { fetchData() }, [fetchData])

  const fetchDelete = async () => {
    try { await api.delete("delete-role/" + roleId); fetchData() } catch (err) { console.error(err) }
  }

  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(roles.length > 0 && roles.every(r => n[r.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; roles.forEach(r => { items[r.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  const getSelectedIds = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try {
      await api.post("delete-multiple-role", { items: ids })
      setCheckedItems({}); setParentChecked(false); fetchData()
    } catch (err) { console.error(err) }
  }

  // Get unique access levels for filter dropdown
  const uniqueLevels = useMemo(() => {
    const set = new Set()
    roles.forEach(r => { if (r.access_level) set.add(String(r.access_level)) })
    return [...set].sort()
  }, [roles])

  const filtered = useMemo(() => {
    return roles.filter(item => {
      const name = (item.setting_name || "").toString().toLowerCase()
      const level = (item.access_level || "").toString().toLowerCase()
      return name.includes(search.rolesType.toLowerCase()) &&
        level.includes(search.accessLevel.toLowerCase())
    })
  }, [roles, search])

  const removeFilter = () => {
    setSearch({ rolesType: "", accessLevel: "" })
    setShowFilter(!showFilter)
  }

  const LEVEL_COLORS = {
    "Admin": "#dc2626", "Company": "#6366f1", "Plant": "#0ea5e9",
    "CC": "#22c55e", "Route": "#f59e0b", "Center": "#8b5cf6", "Client": "#6c757d",
  }

  return (
    <>
      <div className="dashBody">
        {canDelete(MID) && selectedCount > 0 && (
          <button className="delete-button" onClick={() => setconfirm_multiple_alert(true)}>
            <i className="fa fa-trash"></i> <span className="badge bg-white text-danger ms-1">{selectedCount}</span>
          </button>
        )}
        <button className="filter_rel btn btn-primary" onClick={removeFilter}>
          <i className="fa fa-filter"></i>
          {showFilter && <i className="rel_filter_ban fa fa-ban"></i>}
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Roles</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && (
                <Link className="dashBtn" to="/add-role">
                  <i className="fas fa-plus-square"></i> <b>Add New</b>
                </Link>
              )}
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="rolesData">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>S.NO</th>
                <th>Role Name</th>
                <th>Access Level</th>
                <th>Permissions</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td>
                    <input type="text" className="form-control form-control-sm"
                      onChange={e => setSearch({ ...search, rolesType: e.target.value })}
                      value={search.rolesType} placeholder="Search by role" />
                  </td>
                  <td>
                    <select className="form-control form-control-sm"
                      onChange={e => setSearch({ ...search, accessLevel: e.target.value })}
                      value={search.accessLevel}>
                      <option value="">All Levels</option>
                      {uniqueLevels.map((lvl, i) => (
                        <option key={i} value={lvl}>{lvl}</option>
                      ))}
                    </select>
                  </td>
                  <td></td><td></td>
                </tr>
              )}
              {!dataLoaded ? (
                <tr><td colSpan={6}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
              ) : filtered.length > 0 ? (
                filtered.map((role, i) => {
                  // Count permissions from role_settings
                  let permCount = 0
                  try {
                    const settings = typeof role.role_settings === "string" ? JSON.parse(role.role_settings || "{}") : (role.role_settings || {})
                    Object.values(settings).forEach(v => {
                      (v || "").split("").forEach(c => { if (c === "1") permCount++ })
                    })
                  } catch (e) { /* ignore */ }
                  const color = LEVEL_COLORS[role.access_level] || "#6c757d"
                  return (
                    <tr key={role.id}>
                      <td><input type="checkbox" checked={!!checkedItems[role.id]} onChange={() => handleCheckbox(role.id)} /></td>
                      <td>{i + 1}</td>
                      <td style={{ fontWeight: "600" }}>{role.setting_name}</td>
                      <td>
                        <span style={{
                          background: color + "15", color: color, padding: "3px 10px",
                          borderRadius: "12px", fontSize: "12px", fontWeight: "600",
                          border: `1px solid ${color}30`
                        }}>
                          {role.access_level}
                        </span>
                      </td>
                      <td>
                        {permCount > 0 ? (
                          <span className="badge bg-success" style={{ fontSize: "11px" }}>
                            {permCount} enabled
                          </span>
                        ) : (
                          <span className="badge bg-secondary" style={{ fontSize: "11px" }}>Default</span>
                        )}
                      </td>
                      <td>
                        {canEdit(MID) && <Link to={"/edit-role/" + role.id}>
                          <i className="fas fa-edit icons icon-edit"></i>
                        </Link>}
                        {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                          onClick={() => { setRoleId(role.id); setconfirm_alert(true) }}
                          id="sa-success"></i>}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr><td colSpan={6} className="text-center py-4">
                  <i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>No roles found
                </td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { fetchDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Role deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title={`Delete ${selectedCount} roles?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { getSelectedIds(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Selected roles deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default Roles
